import axios from '../http'

function add(data) {
    return axios.post('/basedata/teamLeader/add', data);
}

function del(data) {
    return axios.post('/basedata/teamLeader/del', data);
}

function update(data) {
    return axios.post('/basedata/teamLeader/update', data);
}

function query(data) {
    return axios.post('/basedata/teamLeader/query', data);
}


function get(id) {
    return axios.get('/basedata/teamLeader/get?id=' + id);
}

function find(data) {
    return axios.post('/basedata/teamLeader/find', data);
}

export default {
    add,
    del,
    update,
    query,
    get,
    find
}